import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, ChevronDownIcon, ShieldCheckIcon } from 'lucide-react';
const faqs = [['¿Necesito un diagnóstico o un test de SIBO?', 'No. El sistema no reemplaza ni modifica ninguna indicación médica. Ordena tu alimentación y tus horarios para que el tratamiento que ya tengas indicado funcione mejor.'], ['¿Los alimentos son caros o difíciles de conseguir?', 'No. Todo se consigue en el supermercado de tu barrio. Sin suplementos importados ni dietéticas especializadas.'], ['¿Sirve tanto para hombres como para mujeres?', 'Absolutamente. El protocolo trabaja sobre la fermentación intestinal y los horarios de comida, y funciona igual sin distinción de género.'], ['¿Cuándo veo resultados?', 'La mayoría nota los primeros cambios entre el día 7 y el día 14, especialmente en la hinchazón después de comer y en los gases.'], ['¿La garantía es real?', 'Sí. Si en 30 días no cumplió lo que esperabas, escribís a soportebiomalivido@gmail.com y te devolvemos el 100%. Sin preguntas.'], ['¿Es 100% digital?', 'Sí. Acceso inmediato en PDF. Podés leerlo en el celular, tablet o computadora, e imprimirlo si preferís.']] as const;
const costs = ['Otro mes evitando comidas afuera por miedo a hincharte', 'Más días eliminando alimentos al azar y sin ningún resultado', 'Noches con dolor, gases y la panza dura que no te dejan dormir', 'Consultas donde llegás con sensaciones vagas y salís sin respuestas', 'Plata gastada en probióticos y tés que nunca te ordenaron la dieta', 'Otro año sintiéndote inflamada en tu propio cuerpo'];
const purchases = [['Susana C.', 'Buenos Aires'], ['Rosa M.', 'Córdoba'], ['Elena P.', 'Rosario'], ['Marcela F.', 'Mendoza']];
export function GuaranteeAndFaq() {
  const [open, setOpen] = useState<number | null>(null);
  return <>
      <section className="bg-brand-dark px-4 py-16 sm:py-24" data-id="element-20" data-mp="1z04zyjiqotcy">
        <div className="mx-auto max-w-3xl text-center" data-id="element-21" data-mp="1yzmwb1tqzcv0">
          <ShieldCheckIcon className="mx-auto h-16 w-16 text-brand-light" aria-hidden="true" data-id="element-22" data-mp="230oxvpb50105" />
          <h2 className="mt-5 font-display text-3xl font-bold sm:text-4xl" data-id="element-23" data-mp="27sqibyigky19">
            GARANTÍA 30 DÍAS — SIN PREGUNTAS
          </h2>
          <div className="mt-8 rounded-2xl border-2 border-brand-green/40 p-7 sm:p-10" data-id="element-24" data-mp="1g10t9heo7bog">
            <p className="text-slate-300" data-id="element-25" data-mp="1g3dkyma8d0ep">
              Abrís los volúmenes. Seguís el sistema.
            </p>
            <p className="mt-4 text-slate-300" data-id="element-26" data-mp="1p1p9mirjdo4i">
              Si en 30 días no es lo que esperabas, te devolvemos el 100%.
            </p>
            <p className="mt-5 font-display text-3xl font-bold text-brand-light sm:text-4xl" data-id="element-27" data-mp="1u1toy5gpkct5">
              Devolución del 100%
            </p>
            <p className="mt-2 text-lg font-bold" data-id="element-28" data-mp="30iytv7ihok6v">
              sin formularios, sin drama.
            </p>
          </div>
          <p className="mt-5 text-sm text-slate-400" data-id="element-29" data-mp="tsc5z8rqf214">
            Tasa de devoluciones: menos del 1%.
          </p>
        </div>
      </section>

      <section className="bg-brand-ink px-4 py-16 sm:py-24" data-id="element-30" data-mp="ou0xp2h34zl0">
        <div className="mx-auto max-w-3xl" data-id="element-31" data-mp="k2ahifvgvhlo">
          <h2 className="text-center font-display text-3xl font-bold sm:text-4xl" data-id="element-32" data-mp="k17pg4mer946">
            PREGUNTAS FRECUENTES
          </h2>
          <div className="mt-10 space-y-3" data-id="element-33" data-mp="b248p7apr5su">
            {faqs.map(([question, answer], index) => {
            const panelId = `faq-panel-${index}`;
            return <div key={question} className="overflow-hidden rounded-xl border border-white/10 bg-brand-dark" data-id="element-34" data-mp="6542mwdv631q" data-mpi={index}>
                  <button type="button" onClick={() => setOpen(open === index ? null : index)} aria-expanded={open === index} aria-controls={panelId} className="flex w-full items-center justify-between gap-4 p-5 text-left font-bold sm:text-lg" data-id="element-35" data-mp="3sbanz4psid3w">
                    <span data-id="element-36" data-mp="23idhnmfybfcw">{question}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand-light transition-transform duration-200 ease-out ${open === index ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-37" data-mp="23hc49bbgqgs0" />
                  </button>
                  <AnimatePresence initial={false} data-id="element-38" data-mp="1fsswqy08m80z">
                    {open === index && <motion.div id={panelId} initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.22,
                  ease: [0.23, 1, 0.32, 1]
                }} data-id="element-39" data-mp="1kk18i0p1i5hb">
                        <p className="border-t border-white/10 px-5 py-5 leading-relaxed text-slate-300" data-id="element-40" data-mp="r86dolz2mm8b">
                          {answer}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>;
          })}
          </div>
        </div>
      </section>
    </>;
}
export function CostSection() {
  return <section className="bg-brand-dark px-4 py-16 sm:py-24" data-id="element-41" data-mp="19yfqsqwebyes">
      <div className="mx-auto max-w-4xl" data-id="element-42" data-mp="19xw6x4n6qzy4">
        <h2 className="text-center font-display text-3xl font-bold text-brand-gold sm:text-4xl" data-id="element-43" data-mp="15xcdoc5qggh9">
          ¿CUÁNTO CUESTA NO TENER EL SISTEMA?
        </h2>
        <div className="mt-10 overflow-hidden rounded-2xl border border-[#1a4a2e]" data-id="element-44" data-mp="1jx4zbt2ek6id">
          {costs.map(item => <p key={item} className="border-b border-l-4 border-[#1a4a2e] border-l-[#2d6b45] bg-[#0d2f1e] px-5 py-4 font-medium last:border-b-0" data-id="element-45" data-mp="1evxrju09f7bp">
              <span className="mr-2 text-red-400" aria-hidden="true" data-id="element-46" data-mp="gjv6viynnyam">
                ×
              </span>
              {item}
            </p>)}
        </div>
        <p className="mt-12 text-center text-xl font-bold" data-id="element-47" data-mp="qcj0k4uc9m54">
          El próximo lunes puede ser diferente.
        </p>
        <p className="mx-auto mt-5 max-w-3xl text-center font-display text-xl font-bold italic text-brand-light sm:text-2xl" data-id="element-48" data-mp="vaklkvbbrvj8">
          “Tu intestino no está roto. Solo está esperando el orden correcto.”
        </p>
      </div>
    </section>;
}
export function FooterAndProofPopup() {
  const [purchase, setPurchase] = useState(0);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const timer = window.setInterval(() => {
      setPurchase(value => (value + 1) % purchases.length);
      setVisible(true);
      window.setTimeout(() => setVisible(false), 5000);
    }, 40000);
    return () => window.clearInterval(timer);
  }, []);
  return <>
      <footer className="border-t border-white/10 bg-brand-ink px-4 py-12 text-center" data-id="element-49" data-mp="2yqphnd12kh8l">
        <span className="inline-block rounded-full border border-brand-green/25 bg-brand-green/10 px-3 py-1 text-sm font-semibold text-brand-light" data-id="element-50" data-mp="2trw2lg64wi6b">
          PROTOCOLO — RESCATE SIBO™
        </span>
        <p className="mx-auto mt-4 max-w-md font-semibold text-slate-300" data-id="element-51" data-mp="3mga4i70cfyn5">
          El primer sistema práctico para quienes quieren desinflamar la panza y
          volver a comer sin miedo, paso a paso.
        </p>
        <p className="mx-auto mt-2 max-w-md text-sm italic text-slate-500" data-id="element-52" data-mp="3chufc9kvmzga">
          Porque tu intestino no está roto. Solo está esperando el orden
          correcto.
        </p>
        <div className="mt-7 flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm text-slate-400" data-id="element-53" data-mp="2151n6xo6c8zp">
          <a className="hover:text-brand-light" href="mailto:soportebiomalivido@gmail.com" data-id="element-54" data-mp="1x1c06cn5dzgs">
            📧 soportebiomalivido@gmail.com
          </a>
        </div>
        <p className="mt-8 text-xs text-slate-600" data-id="element-55" data-mp="51wwjk8w1wqq">
          © BIOMA LÍVIDO™ 2026 — Todos los derechos reservados.
        </p>
      </footer>

      <AnimatePresence data-id="element-56" data-mp="3n8joxfixhk2f">
        {visible && <motion.aside initial={{
        x: -30,
        opacity: 0
      }} animate={{
        x: 0,
        opacity: 1
      }} exit={{
        x: -30,
        opacity: 0
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="fixed bottom-5 left-5 z-50 max-w-[285px] rounded-xl border border-brand-green/30 bg-brand-ink p-4 shadow-2xl" aria-live="polite" data-id="element-57" data-mp="3s4rymdecwl27">
            <p className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-brand-light" data-id="element-58" data-mp="17fca5p2m18fq">
              <CheckCircle2Icon className="h-4 w-4" aria-hidden="true" data-id="element-59" data-mp="1gtw9q1wue7jb" />
              Compra verificada
            </p>
            <p className="mt-2 text-sm font-semibold" data-id="element-60" data-mp="1ctc92od28lsf">
              {purchases[purchase][0]} de {purchases[purchase][1]}
            </p>
            <p className="text-sm text-slate-300" data-id="element-61" data-mp="1qj5yp8we3a37">
              compró Protocolo — Rescate SIBO™
            </p>
            <p className="mt-1 text-xs text-slate-500" data-id="element-62" data-mp="1ln76tbbur9y1">hace unos minutos</p>
          </motion.aside>}
      </AnimatePresence>
    </>;
}